import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';
import Script from 'next/script';
import '../styles/globals.css';
import { ConsentManager, gtmDataLayerScript, gtmScript, gtmNoScript } from '../utils/ConsentUtils';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  
  // Инициализация dataLayer при монтировании компонента
  useEffect(() => {
    // Загрузка dataLayer скрипта
    const dataLayerScript = document.createElement('script');
    dataLayerScript.innerHTML = gtmDataLayerScript;
    document.head.appendChild(dataLayerScript);
    
    // Загрузка GTM скрипта
    const gtmScriptElement = document.createElement('script');
    gtmScriptElement.innerHTML = gtmScript;
    gtmScriptElement.onload = () => {
      console.log('✅ GTM script loaded');
    };
    document.head.appendChild(gtmScriptElement);
    
    return () => {
      // Удаляем скрипты при размонтировании компонента
      if (dataLayerScript.parentNode) {
        dataLayerScript.parentNode.removeChild(dataLayerScript);
      }
      if (gtmScriptElement.parentNode) {
        gtmScriptElement.parentNode.removeChild(gtmScriptElement);
      }
    };
  }, []);

  return (
    <>
      <Head>
        <title>My App</title>
      </Head>
      
      <Component {...pageProps} />
      
      {/* GTM noscript tag */}
      <noscript dangerouslySetInnerHTML={{ __html: gtmNoScript }} />
      
      {/* Consent Management Component */}
      <ConsentManager />
    </>
  );
}

export default MyApp;